import './polyfills/material-form-association';

/**
 * setImmediate, globalThis and intl.list-format polyfills should be imported
 * through core-js and babel. And indeed on development environment they are
 * used through core-js.
 *
 * But due do building process limitations they should be manually polyfilled
 * here until this issue https://github.com/rollup/plugins/pull/1038 is resolved
 * and the resolution is tested on our build environment.
 *
 * @todo [user-interfaces]   Test new plugin-commonjs when issue above is
 *                           resolved.
 * @todo [web-browser-port]  Document why these polyfills are needed.
 */
import 'setimmediate/setImmediate'; // TODO [test] replace for a parameter for polyfill.io or polyfill.app
import './polyfills/global-this'; // TODO [extensions] move to @quentar/extensions package, since it will store all language extensions and utilities
import './polyfills/blob.array-buffer';

// TODO [web-browser-port] move most polyfills to the core-js/babel plugin integration
// import "https://polyfill.app/api/polyfill?features=intl.list-format"

/**
 * Sometimes delivery-interface.js is not loaded by the browser, updating the delivery status here
 * allows for initial-state (bootstrap) script to confirm that the delivery mechanism has
 * successfully finished delivering.
 */
globalThis.INITIAL_STATE.delivery.status = 'finished';
